import React, { useState, Fragment } from 'react';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';

import fobkLogo from '../assets/img/FoBK_Navbar.png'

import LoginModal from './auth/LoginModal'
import RegisterModal from './auth/RegisterModal'
import Logout from './auth/Logout'
import AdminNavItems from './AdminNavItems';

const NavBar = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen(!isOpen);
    const userDetails = props.userDetails
    const isAdmin = userDetails?.user?.permissionLevel === 'Admin'

    return (
        <div className='fobk-navbar-wrap'>
            <Navbar className='fobk-navbar' color="light" light expand="lg">
                <NavbarBrand href="/" className='fobk-brand'>
                    <img src={fobkLogo} alt="Friends of Bukit Kiara" className='fobk-brand__mark' />
                    <div className='fobk-brand__copy'>
                        <span className='fobk-brand__eyebrow'>Community Stewardship</span>
                        <span className='fobk-brand__title'>Friends of Bukit Kiara</span>
                    </div>
                </NavbarBrand>
                <NavbarToggler onClick={toggle} />
                <Collapse isOpen={isOpen} navbar>
                    {!props.hideNavbar && <Nav className="ms-auto fobk-nav" navbar>
                        <NavItem>
                            <NavLink
                                href="https://www.fobk.org/"
                                target="_blank"
                                rel="noreferrer"
                                className='auth-nav-link auth-nav-link--site'
                            >
                                Visit FoBK.org
                            </NavLink>
                        </NavItem>
                        {props.authenticated // TO display different Navbars for each state
                            ? <Fragment>
                                <AdminNavItems isAdmin={isAdmin} />
                                <NavItem>
                                    <NavLink href="/">Dashboard</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="/eventregister">Register For Events</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="#donate" className='auth-nav-link auth-nav-link--primary'>Support Us</NavLink>
                                </NavItem>
                                <li className="nav-item d-none d-lg-block" aria-hidden="true">
                                    <div className="vertical-divider" />
                                </li>
                                <NavItem>
                                    <Logout setAuthenticated={props.setAuthenticated} />
                                </NavItem>
                            </Fragment>
                            : (props.invalidToken && <Fragment>
                                <NavItem>
                                    <NavLink href="/eventregister">Explore Events</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink href="#donate" className='auth-nav-link auth-nav-link--primary'>Support Us</NavLink>
                                </NavItem>
                                <li className="nav-item d-none d-lg-block" aria-hidden="true">
                                    <div className="vertical-divider" />
                                </li>
                                <NavItem>
                                    <RegisterModal
                                        label="Register"
                                        setAuthenticated={props.setAuthenticated}
                                        triggerClassName='auth-nav-link auth-nav-link--primary'
                                    />
                                </NavItem>
                                <NavItem>
                                    <LoginModal
                                        label="Login"
                                        setAuthenticated={props.setAuthenticated}
                                        triggerClassName='auth-nav-link auth-nav-link--secondary'
                                    />
                                </NavItem>
                            </Fragment>)
                        }

                    </Nav>}
                </Collapse>
            </Navbar>
        </div >
    );
}

export default NavBar;
